<template>
  <b-modal
    v-model="modalData.enabled"
    id="bv-modal-ajuda"
    size="xl"
    hide-footer
    centered
    scrollable
  >
    <div v-html="modalData.text"></div>
  </b-modal>
</template>

<script>
export default {
  name: 'ModalAjuda',
  props: {
    modalData: {
      type: Object,
      required: true,
      default: () => ({
        enabled: false,
        text: '',
      }),
    },
  },
}
</script>
